import React, { useState } from 'react';

import constants from 'constants/constants';
import moment from 'moment-timezone';
import colorsVars from 'styles/colors.module.scss';

import { CustomizedRoundIcon } from 'components/common/CustomizedRoundIcon/CustomizedRoundIcon';
import { CustomizedTooltip } from 'components/common/CustomizedTooltip/CustomizedTooltip';
import { MuiIcon } from 'components/common/Icons/base/MuiIcon/MuiIcon';
import classes from 'components/common/Tables/Cells/DetailsCell/DetailsCell.module.scss';
import { AddCommentWidget } from 'components/common/Tables/Cells/DetailsCell/components/AddCommentWidget/AddCommentWidget';

const { white } = colorsVars;
export interface ICardLastComment {
    lastComment: string;
    lastCommentCreatedDate: number;
    lastCommentFirstUserName: string;
    lastCommentLastUserName: string;
}

interface IDetailsCellProps {
    details: string;
    cardLastComment: ICardLastComment | null;
    id: number;
    invalidateQueriesKey: string[];
    isVirtual: boolean;
    isGenAiDetails: boolean;
}

export const DetailsCell = ({
    details,
    cardLastComment,
    id,
    invalidateQueriesKey,
    isVirtual,
    isGenAiDetails,
}: IDetailsCellProps) => {
    const [isAddComment, setIsAddComment] = useState<boolean>(false);
    const addComment = () => {
        setIsAddComment(true);
    };

    const now = moment();
    const publishedDate =
        cardLastComment &&
        moment(cardLastComment.lastCommentCreatedDate).format(constants.formats.date.fullDateWithMilliSeconds);
    const publishedDateHumanize =
        cardLastComment && moment.duration(moment(cardLastComment?.lastCommentCreatedDate).diff(now)).humanize(true);

    const isMoreThenMonthAgo = now?.diff(moment(cardLastComment?.lastCommentCreatedDate), 'month') !== 0;

    return (
        <div className={classes.detailsCell}>
            {isAddComment ? (
                <div className={classes.addCommentContainer}>
                    <AddCommentWidget
                        id={id}
                        setIsAddComment={setIsAddComment}
                        invalidateQueriesKey={invalidateQueriesKey}
                        isVirtual={isVirtual}
                    />
                </div>
            ) : (
                <CustomizedTooltip
                    contentStyles={{ maxWidth: 800 }}
                    tooltipContent={
                        <div>
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: cardLastComment ? cardLastComment.lastComment : details,
                                }}
                            />
                        </div>
                    }
                    triggerElement={
                        <div className={classes.content}>
                            {cardLastComment ? (
                                <div>
                                    <div className={classes.singleLineText}>
                                        <span dangerouslySetInnerHTML={{ __html: cardLastComment.lastComment }} />
                                    </div>
                                </div>
                            ) : (
                                <div>
                                    <div className={classes.singleLineText}>
                                        <span dangerouslySetInnerHTML={{ __html: details }} />
                                    </div>
                                    {isGenAiDetails && (
                                        <div className={classes.aiGenerated}>AI Generated narrative</div>
                                    )}
                                </div>
                            )}
                        </div>
                    }
                />
            )}

            {cardLastComment && !isAddComment && (
                <div className={classes.latestCommentDetails}>
                    <span>Latest comment,</span>
                    <span>{isMoreThenMonthAgo ? publishedDate : publishedDateHumanize}</span>
                    <span>
                        by {cardLastComment.lastCommentFirstUserName} {cardLastComment.lastCommentLastUserName}
                    </span>
                </div>
            )}

            {!isAddComment && (
                <div className={classes.actionButtons}>
                    <CustomizedTooltip
                        tooltipContent={'Add Comment'}
                        triggerElement={
                            <CustomizedRoundIcon
                                onClick={addComment}
                                backGroundColor={'var(--button-primary-bg)'}
                                hoverColor={'var(--button-primary-bg_hover)'}
                            >
                                <MuiIcon icon={'playlist_add'} color={'var(--button-primary-fg)'} />
                            </CustomizedRoundIcon>
                        }
                    />
                </div>
            )}
        </div>
    );
};
